import { Wizard } from "react-use-wizard";
import Content from "../Content";
import Footer from "../Footer";
import ImageWithCaption from "../ImageWithCaption";
import MetaMaskImport from "../assets/Metamask/Wallet/Frame02.png";
import MetaMaskTele from "../assets/Metamask/Wallet/Frame03.png";
import Recovery from "../assets/Metamask/Wallet/Frame04.png";

import ExtensionCard from "../ExtensionCard";
import { StepProps } from "./MetamaskCreate";

const MetamaskAdd: React.FC<StepProps> = ({ setFlowState, prevState }) => {
  return (
    <Wizard
      footer={
        <Footer
          setFlowState={setFlowState}
          prevState={prevState}
          currentState="metamaskAdd"
        />
      }>
      <Content title="Download the MetaMask plugin on Google Chrome, and open it.">
        <ExtensionCard wallet="mm" />
      </Content>
      <Content
        title={
          <>
            <span className="font-normal">Select </span>
            <span className="text-coinage-blue font-bold">Import Wallet.</span>
          </>
        }>
        <ImageWithCaption
          src={MetaMaskImport}
          caption="Image: MetaMask"
          altText="Adding coinbase wallet image"
        />
      </Content>
      <Content
        title={
          <>
            <span className="font-normal">
              When it asks if you want to help improve MetaMask, select{" "}
            </span>
            <span className="text-coinage-blue">No Thanks.</span>
          </>
        }>
        <ImageWithCaption
          src={MetaMaskTele}
          caption="Image: MetaMask"
          altText="Adding metamask wallet image"
        />
      </Content>
      <Content
        title="Enter your secret recovery phrase."
        description={
          <>
            Create a password, and agree to the terms of use. Then, select{" "}
            <span className="text-coinage-blue font-bold">Import.</span>
            <br />I can’t find my recovery phrase
          </>
        }
        tooltipContent={{
          title: "Recovery Phrase Tip",
          description: (
            <>
              If you can’t find your recovery phrase, you need to make a new
              wallet. Create a new wallet
              <button
                className="underline"
                onClick={() =>
                  setFlowState({
                    prev: "initial",
                    current: "createWalletIntro"
                  })
                }>
                here.
              </button>
            </>
          )
        }}>
        <ImageWithCaption
          src={Recovery}
          caption="Image: MetaMask"
          altText="Adding coinbase wallet image"
        />
      </Content>
    </Wizard>
  );
};

export default MetamaskAdd;
